import React from "react";
import {
  WhatsappShareButton,
  FacebookShareButton,
  TwitterShareButton,
  InstapaperShareButton,
  PinterestShareButton,
} from "react-share";

export default function SocialShare(props) {
  const location =
    props?.link ??
    "https://play.google.com/store/apps/details?id=com.mntreecapitalalrobopro.com";
  const description = props.description;
  const shareImage = props.image;

  return (
    <div className="social-share">
      <WhatsappShareButton
        url={location}
        description={description}
        media={`${shareImage}`}
        windowWidth={1000}
        windowHeight={730}
      >
        <i className="fa fa-whatsapp" aria-hidden="true"></i>
      </WhatsappShareButton>
      <FacebookShareButton
        url={location}
        description={description}
        media={`${shareImage}`}
        windowWidth={1000}
        windowHeight={730}
      >
        <i className="fa fa-facebook" aria-hidden="true"></i>
      </FacebookShareButton>

      <InstapaperShareButton
        url={location}
        description={description}
        media={`${shareImage}`}
        windowWidth={1000}
        windowHeight={730}
      >
        <i className="fa fa-instagram" aria-hidden="true"></i>
      </InstapaperShareButton>

      <TwitterShareButton
        url={location}
        description={description}
        media={`${shareImage}`}
        windowWidth={1000}
        windowHeight={730}
      >
        <i className="fa fa-twitter" aria-hidden="true"></i>
      </TwitterShareButton>

      <PinterestShareButton
        url={location}
        description={description}
        media={`${shareImage}`}
        windowWidth={1000}
        windowHeight={730}
      >
        <i className="fa fa-pinterest" aria-hidden="true"></i>
      </PinterestShareButton>
    </div>
  );
}
